import React, { useMemo, useState } from 'react';
import { Hit, ProductObject } from '../../algoliaPopularProduct/type';
import Wrapper from 'components/HOC/wrapper';
import { ChevronRightIcon, ChevronLeftIcon } from '@heroicons/react/24/solid';
import Loading from 'components/commercetools-ui/atoms/loading';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
import { desktop, tablet } from 'helpers/utils/screensizes';
import ProductTile from './productTile';
type ProductProps = {
  products: Hit[];
  cookies: any;
};

const CategoryCarousel = (algoliaHits: ProductProps) => {
  const [isDesktopSize] = useMediaQuery(desktop);
  const [isTablet] = useMediaQuery(tablet);
  const [startIndex, setStartIndex] = useState(0);

  const visibleItems = useMemo(() => {
    if (isDesktopSize) return 4;
    if (isTablet) return 3;
    return 2;
  }, [isDesktopSize, isTablet]);

  const newArray = algoliaHits?.products?.map((product: Hit) => ({
    name:
      algoliaHits?.cookies?.locale_selection?.currency === 'GBP'
        ? product?.name?.['en-GB']
        : product?.name?.['en-EU'] || product?.name?.['en-GB'],
    image: product?.variants?.[0]?.images?.[0] || null,
    price: product?.variants?.[0]?.prices || null,
    categoryKey: product?.categoryKeys,
    slug:
      algoliaHits?.cookies?.locale_selection?.currency === 'GBP'
        ? product?.slug?.['en-GB']
        : product?.slug?.['en-EU'] || product?.slug?.['en-GB'],
    standalonePrice: product?.standalonePrice,
  }));

  const handleLeftClick = () => {
    setStartIndex((prevIndex) => (prevIndex - 1 + algoliaHits?.products?.length) % algoliaHits?.products?.length);
  };

  const handleRightClick = () => {
    setStartIndex((prevIndex) => (prevIndex + 1) % algoliaHits?.products?.length);
  };

  const renderItems = (items: ProductObject[]) => {
    if (items.length === 0) return null;
    const loopedItems = [...items, ...items, ...items];
    const start = (items?.length ?? 0) + startIndex;
    const end = start + Math.ceil(visibleItems);
    return loopedItems?.slice(start, end)?.map((item, index) => <ProductTile product={item} key={index} />);
  };
  const isMobileView = typeof window !== 'undefined' && window.innerWidth <= 320;
  return (
    <div className="w-full">
      <>
        <Wrapper clearDefaultStyles className="relative px-13 pb-32 pt-16">
          {/* <div
            className={`mb-16 flex items-center ${
              isDesktopSize || algoliaHits?.products?.length === 0 ? 'relative justify-center' : 'justify-between pr-10'
            }`}
          > */}
          {algoliaHits?.products?.length > 4 && (
            <div className="absolute left-0 right-0 top-1/2 flex -translate-y-1/2 justify-between px-4">
              <button
                className={`flex h-${isMobileView ? '30' : '40'} w-${
                  isMobileView ? '30' : '40'
                } items-center justify-center rounded-full bg-black shadow-md transition-all duration-300 ${
                  isMobileView ? 'left-2' : 'left-[-30px]'
                }`}
                onClick={handleLeftClick}
              >
                <ChevronLeftIcon
                  className={`h-${isMobileView ? '16' : '20'} w-${isMobileView ? '16' : '20'} text-white`}
                />
              </button>
              <button
                className={`flex h-${isMobileView ? '30' : '40'} w-${
                  isMobileView ? '30' : '40'
                } items-center justify-center rounded-full bg-black shadow-md transition-all duration-300 ${
                  isMobileView ? 'right-2' : 'left-[1095px]'
                }`}
                onClick={handleRightClick}
              >
                <ChevronRightIcon
                  className={`h-${isMobileView ? '16' : '20'} w-${isMobileView ? '16' : '20'} text-white`}
                />
              </button>
            </div>
          )}
          {/* </div> */}
          {algoliaHits?.products?.length === 0 ? (
            <Loading />
          ) : algoliaHits?.products?.length > 4 ? (
            <div
              className="flex w-full items-stretch justify-around
            overflow-hidden"
            >
              {renderItems(newArray as ProductObject[])}
            </div>
          ) : (
            <div className=" flex flex-wrap justify-center gap-6">
              {newArray?.map((product, index) => (
                <ProductTile product={product} key={index} />
              ))}
            </div>
          )}
        </Wrapper>
      </>
    </div>
  );
};

export default CategoryCarousel;
